export const medias = state => state.activePost.medias;
export const activePost = state => state.activePost;
export const media = (state) => {
  if (state.activePost.medias.length) {
    return state.activePost.medias.filter(mediaToCheck => mediaToCheck.is_primary_by_slug)[0];
  }

  return {};
};



// WEBPACK FOOTER //
// ./src/screens/Class/Index/store/getters.js